import { createAction, props } from '@ngrx/store';
import { EProductPublishingStatusInfo } from '@api-ui-app/src/app/e-commerce-product-publishing/types/e-product-publishing-status-info';
import { SplashMessage } from '@api-ui-app/src/app/shared/splash-message/lib/splash-message';
import { EProductPublishingErrorCode } from '@gelato-api-ui/core/e-commerce/e-product-publishing-errors.enum';
import { EProductPublishingDetailsFlag } from '@gelato-api-ui/core/e-commerce/e-product-publishing-details-flag.enum';

export const initiatePublishingProcessMonitoring = createAction(
  '[ECommerceProductPublishing] Initiate Publishing Process Monitoring',
  props<{ statuses: string[] }>(),
);

export const cancelPublishingProcessMonitoring = createAction(
  '[ECommerceProductPublishing] Cancel Publishing Process Monitoring',
);

export const showStatusMessage = createAction(
  '[ECommerceProductPublishing] Show Status Message',
  props<{ payload: EProductPublishingStatusInfo }>(),
);

export const hideAllStatusMessages = createAction('[ECommerceProductPublishing] Hide All Status Messages');

export const hideStatusMessage = createAction(
  '[ECommerceProductPublishing] Hide Status Message',
  props<{ productId: string }>(),
);

export const showSuccessStatusMessage = createAction(
  '[ECommerceProductPublishing] Show Success Status Message',
  props<{ productId: string; productTitle: string; detailsFlags: EProductPublishingDetailsFlag[] }>(),
);

export const showErrorStatusMessage = createAction(
  '[ECommerceProductPublishing] Show Error Status Message',
  props<{ productId: string; productTitle: string; errorCode: EProductPublishingErrorCode; errorDetails?: string }>(),
);

export const showInfoNotification = createAction(
  '[ECommerceProductPublishing] Show Info Notification',
  props<{ payload: Partial<SplashMessage> }>(),
);

export const showProductSavingStartInfoMessage = createAction(
  '[ECommerceProductPublishing] Show Product Saving Start Info Message',
  props<{ publishImmediately: boolean }>(),
);
